export const UPDATE_OPERATION = "U"
export const PERIOD = {
    'Manhã': 'Manhã',
    'Tarde': 'Tarde'
}

export const TIME_PERIOD = {
    'Manhã': '09:00-11:30',
    'Tarde': '13:30-17:00'
}


// WEBPACK FOOTER //
// ./src/services/state/rescheduling/constants.js